var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "react", "../../propTypes", "../TeaserShow/TeaserShow", "../../Concert/LiveLabel/LiveLabel", "../../UI/TitlesElement/TitlesElement"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("react"), require("../../propTypes"), require("../TeaserShow/TeaserShow"), require("../../Concert/LiveLabel/LiveLabel"), require("../../UI/TitlesElement/TitlesElement"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.propTypes, global.TeaserShow, global.LiveLabel, global.TitlesElement);
    global.TeaserConcert = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _objectWithoutProperties2, _react, _propTypes, _TeaserShow, _LiveLabel, _TitlesElement) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _TeaserShow = _interopRequireDefault(_TeaserShow);
  _LiveLabel = _interopRequireDefault(_LiveLabel);
  _TitlesElement = _interopRequireDefault(_TitlesElement);

  var TeaserConcert = function TeaserConcert(_ref) {
    var beginsAt = _ref.beginsAt,
        rest = (0, _objectWithoutProperties2.default)(_ref, ["beginsAt"]);
    var teaser = rest;
    var title = teaser.title,
        subtitle = teaser.subtitle;
    var sticker;
    var titlesElement = teaser.titlesElement;

    if (beginsAt && beginsAt !== null) {
      sticker = {
        position: 'top-left',
        className: 'live-sticker',
        label: /*#__PURE__*/_react.default.createElement(_LiveLabel.default, {
          label: beginsAt,
          size: "medium"
        })
      };
    }

    if (teaser.stickers && teaser.stickers.filter(function (_ref2) {
      var code = _ref2.code;
      return code === 'LIVE';
    }).length === 1) {
      sticker = {
        position: 'top-left',
        className: 'live-sticker',
        label: /*#__PURE__*/_react.default.createElement(_LiveLabel.default, {
          live: true,
          size: "medium"
        })
      };
    }

    if (teaser.kind && teaser.kind.code in _propTypes.default.kindMap) {
      teaser.secondaryText = teaser.kind.label;
      delete teaser.kind;
    }

    if (titlesElement) {
      titlesElement = /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
        title: title,
        subtitle: subtitle,
        format: "twolines",
        display: "SLIDER_ITEM_TITLE"
      });
    }

    return /*#__PURE__*/_react.default.createElement(_TeaserShow.default, (0, _extends2.default)({}, teaser, {
      sticker: sticker,
      titlesElement: titlesElement
    }));
  };

  TeaserConcert.propTypes = _TeaserShow.default.propTypes;
  TeaserConcert.defaultProps = _TeaserShow.default.defaultProps;
  var _default = TeaserConcert;
  _exports.default = _default;
});